export default "__VITE_ASSET__DPHJ_2um__"